// extracted by mini-css-extract-plugin
export default {"w-full":"Control_w-full__a6YTU","control":"Control_control__mMDka","button":"Control_button__sf-by"};